import { Link } from "react-router-dom";
import { Lock } from "@phosphor-icons/react";

const INK = "var(--pr-ink)";
const GOLD = "var(--pr-gold)";

// A locked "level", game language, never cold SaaS language.
export const LockedCard = ({
  id,
  icon = "🔒",
  title,
  lockLine = "Season Pass feature",
  body,
  ctaLabel = "Unlock with Season Pass",
  compact = false,
}) => (
  <div
    className={`rounded-2xl border border-dashed ${compact ? "p-4" : "p-5 lg:p-6"}`}
    style={{ background: "var(--pr-bg-alt)", borderColor: "var(--pr-card-line)" }}
    data-testid={id}
  >
    <div className="flex items-start gap-3">
      <span className={`${compact ? "text-xl" : "text-2xl"} opacity-60 grayscale`}>{icon}</span>
      <div className="flex-1 min-w-0">
        <p className="font-bold text-sm flex items-center gap-1.5" style={{ color: INK }}>
          {title}
          <Lock className="w-3.5 h-3.5" style={{ color: "var(--pr-muted)" }} />
        </p>
        <p className="text-[11px] font-bold uppercase tracking-widest mt-0.5" style={{ color: "var(--pr-muted)" }}>
          {lockLine}
        </p>
        {body && (
          <p className="text-xs leading-relaxed mt-1.5" style={{ color: "var(--pr-ink2)" }}>{body}</p>
        )}
        <Link
          to="/start/season-pass"
          className="inline-block mt-3 px-4 py-2 rounded-full font-bold text-xs pr-btn-primary"
          data-testid={id ? `${id}-cta` : undefined}
        >
          {ctaLabel} →
        </Link>
      </div>
    </div>
  </div>
);
